module.exports = __webpack_public_path__ + "static/media/order.baf71d0f.svg";